import { Perfumes } from "../../components";
import "./stylesCategoriaPerfumes.scss";

export const CategoriaPerfumes = () => (
  <div>
    <Perfumes />
  </div>
);
